module.exports = __webpack_public_path__ + "static/media/Hotel-4@2x.96dae539.png";